import { useMutation } from 'react-query';
import canvasRequest from '../helpers/canvasRequest';
import CanvasApiError from '../helpers/CanvasApiError';
import type { CanvasMutationVariables, UseCanvasMutationParams } from '../types';

// react-query write wrapper for canvas endpoints. The concrete path and body are
// passed per mutate() call so one hook instance can target sub-resources; auth +
// org headers are added by canvasRequest. Invalidation stays the caller's job.
const useCanvasMutation = <TBody, TResult>({
    organizationId,
    method = 'POST',
    onSuccess = () => {},
    onError = () => {},
}: UseCanvasMutationParams<TResult>) =>
    useMutation<TResult, CanvasApiError, CanvasMutationVariables<TBody>>(
        ({ path, body }: CanvasMutationVariables<TBody>) =>
            canvasRequest<TResult>({ method, path, organizationId, body }),
        { onSuccess, onError }
    );

export default useCanvasMutation;
